<template>
    <div>
        <el-row>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
                <el-breadcrumb-item :to="{ path: '/costReport' }" style="font-size:24px">费用管理列表</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:24px">二级费用列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col>
                <el-button @click="addDepartment">新增</el-button>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
            <el-col>
                <el-table :data="departmentData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80" min-width="80"></el-table-column>
                    <el-table-column prop="SECOND_TYPE_NAME" label="名称" ></el-table-column>
                    <el-table-column prop="DEPARTMENT_NAME" label="部门" ></el-table-column>
                    <el-table-column fixed="right" label="操作" width="200">
                        <template slot-scope="scope">
                            <!--<el-button type="text" size="small" @click="openDetail(scope.row)" icon="el-icon-edit">查看</el-button>-->
                            <el-button type="text" size="small" @click="openEdit(scope.row)" icon="el-icon-edit">修改</el-button>
                            <el-button type="text" size="small" icon="el-icon-check" style="color:#67C23A"
                                @click="startDepartment(scope.row)" v-if="scope.row.STATUS === 0">启用
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-close" style="color:  #F56C6C"
                                @click="stopDepartment(scope.row)" v-else>禁用
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-pagination @current-change="handleCurrentChange(e)" :current-page.sync="currentPage" :page-size="pageSize"
                           layout="total, prev, pager, next, jumper" :total="totalNum" style="float: right">
            </el-pagination>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog title="修改费用类别" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
                    <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
                        <el-form-item label="费用类型名称：" prop="NAME">
                            <el-input v-model="editForm.SECOND_TYPE_NAME"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-radio-group v-model="editForm.BE_MULTIPLE_DATA" disabled >
                                <el-radio :label="0">单条</el-radio>
                                <el-radio :label="1">多条</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="close('editForm')">取 消</el-button>
                        <el-button @click="submitEdit()">确 定</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog title="新增费用类别" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
                    <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
                        <el-form-item label="费用类型名称：" prop="NAME">
                            <el-input v-model="addForm.NAME"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template>
                                <el-radio-group v-model="addForm.radio">
                                    <el-radio :label="0">单条</el-radio>
                                    <el-radio :label="1">多条</el-radio>
                                </el-radio-group>
                            </template>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="close('addForm')">取 消</el-button>
                        <el-button @click="submitAdd()">确 定</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      departmentData: [],
      editFormVisible: false,
      addFormVisible: false,
      editForm: {
        BE_MULTIPLE_DATA: '',
      },
      addForm: {
        radio: 0,
      },
      formLabelWidth: '120px',
      departments: [],
      pageSize: 20,
      currentPage: 1,
      totalNum: 0,
    };
  },
  mounted() {
    this.queryList();
  },
  methods: {
    queryList(index) {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 10,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        FIRST_TYPE_ID: this.$route.params.firstId,
        PAGEINDEX: index,
        PAGESIZE: this.pageSize,
      };
      http.post(params).then((result) => {
        this.departmentData = result[0].OP_ROLE;
        this.totalNum = result[0].TOTAL_COUNT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e - 1;
      this.queryList();
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.emp = JSON.parse(JSON.stringify(row.SECOND_TYPE_NAME));
    },
    close() {
      this.editForm.SECOND_TYPE_NAME = this.emp;
      this.addForm.NAME = '';
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.editForm = {};
      this.addForm = {};
    },
    submitEdit() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 7,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            NAME: this.editForm.SECOND_TYPE_NAME,
            FIRST_TYPE_ID: this.$route.params.firstId,
            SECOND_TYPE_ID: this.editForm.SECOND_TYPE_ID,
            BE_MULTIPLE_DATA: this.editForm.radio,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    startDepartment(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 9,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            SECOND_TYPE_ID: row.SECOND_TYPE_ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    stopDepartment(row) {
      this.$confirm('您确定禁用该费用类别吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10013',
          OTYPE: 8,
          TC_ID: Number(sessionStorage.getItem('companyId')),
          SECOND_TYPE_ID: row.SECOND_TYPE_ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    addDepartment() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 6,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            NAME: this.addForm.NAME,
            BE_MULTIPLE_DATA: this.addForm.radio,
            FIRST_TYPE_ID: this.$route.params.firstId,
            DEPARTMENT_ID: this.addForm.DEPARTMENT,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    openDetail() {

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/costReportDetail.vue